var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevOps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e00adf82-3a2b-4d63-88d6-04e0fd613716",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e3494492-9322-4864-b215-4b13d5db2a3c",
    x1: 306.077,
    y1: -363.569,
    x2: 305.834,
    y2: -351.67,
    gradientTransform: "matrix(1, 0, 0, -1, -297, -351)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2889e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50e6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f1488af2-2554-4dd5-a9ad-c1ce2894eaa1",
    x1: 310.996,
    y1: -367.576,
    x2: 305.457,
    y2: -357.862,
    gradientTransform: "matrix(1, 0, 0, -1, -297, -351)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#704cb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c398e9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.85,9.71c-.545,1.979-1.868,2.634-3.293,3.239a1.825,1.825,0,0,1-.694.119H7.714c-1.159,0-2.923-.019-3.747-.028a1.946,1.946,0,0,1-.875-.2A5,5,0,0,1,.153,8.83C.071,8.1-.106,5.123,4.239,3.977A5.33,5.33,0,0,1,9.307.68a5.045,5.045,0,0,1,5.068,4.73C15.823,5.7,18.14,7.13,17.85,9.71Z",
    fill: "url(#e3494492-9322-4864-b215-4b13d5db2a3c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.764,11.866A5.454,5.454,0,1,1,11.31,6.412,5.454,5.454,0,0,1,16.764,11.866Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.31,16.6a4.736,4.736,0,1,0-4.736-4.736A4.736,4.736,0,0,0,11.31,16.6Zm0,.717a5.454,5.454,0,1,0-5.453-5.453,5.453,5.453,0,0,0,5.453,5.453Z",
    fillRule: "evenodd",
    fill: "url(#f1488af2-2554-4dd5-a9ad-c1ce2894eaa1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332,10.9a1.127,1.127,0,0,0-1.124,1.129,2.39,2.39,0,1,1-4.082-1.693,2.371,2.371,0,0,1,1.405-.689v.57a1.835,1.835,0,1,0,2.114,1.812,1.687,1.687,0,0,1,3.368-.141h-.565a1.127,1.127,0,0,0-1.116-.988Z",
    fill: "#417be9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.976,13.061A2.391,2.391,0,1,1,9.531,9.648v.57a1.835,1.835,0,1,0,2.114,1.812,1.7,1.7,0,0,1,.338-1.017A1.686,1.686,0,0,1,15,11.8c0,.031.007.062.01.093h-.565a1.124,1.124,0,0,0-2.24.141,2.4,2.4,0,0,1-.232,1.031ZM9.593,9.578a.1.1,0,0,1,.031.07v.57a.092.092,0,0,1-.078.091,1.743,1.743,0,0,0,.272,3.463,1.7,1.7,0,0,0,.809-.2,1.742,1.742,0,0,0,.926-1.541,1.779,1.779,0,0,1,3.552-.149.091.091,0,0,1-.084.1h-.573a.092.092,0,0,1-.092-.081,1.032,1.032,0,0,0-2.056.13,2.482,2.482,0,1,1-4.24-1.759,2.474,2.474,0,0,1,1.46-.715.094.094,0,0,1,.073.023Z",
    fill: "#417be9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.317,13.77a1.667,1.667,0,0,1-.777-.192l.287-.516a1.111,1.111,0,0,0,.49.114,1.153,1.153,0,0,0,1.11-.89h.586A1.739,1.739,0,0,1,13.317,13.77Z",
    fill: "#1453c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.451,13.6a.092.092,0,0,1,.008-.071l.287-.515a.093.093,0,0,1,.122-.039,1.018,1.018,0,0,0,.45.105,1.063,1.063,0,0,0,1.02-.82.092.092,0,0,1,.09-.071h.585a.093.093,0,0,1,.093.093.077.077,0,0,1,0,.015,1.83,1.83,0,0,1-1.786,1.561,1.75,1.75,0,0,1-.821-.2A.1.1,0,0,1,12.451,13.6ZM15,12.379a1.733,1.733,0,0,1-1.677,1.391,1.674,1.674,0,0,1-.778-.192l.287-.516a1.113,1.113,0,0,0,.491.114,1.155,1.155,0,0,0,1.11-.89h.585Q15.005,12.333,15,12.379Z",
    fill: "#1453c8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3,10.967a1.891,1.891,0,0,0-.356-.359A1.927,1.927,0,0,0,9.9,10.215V9.648a2.533,2.533,0,0,1,1.157.35,2.478,2.478,0,0,1,.656.566Z",
    fill: "#88aef1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.289,11.059a.092.092,0,0,1-.066-.036,1.738,1.738,0,0,0-.339-.341,1.818,1.818,0,0,0-.989-.374.094.094,0,0,1-.086-.093V9.648A.093.093,0,0,1,9.9,9.555h.006a2.623,2.623,0,0,1,1.2.364,2.56,2.56,0,0,1,.681.587.091.091,0,0,1-.008.125l-.418.4a.094.094,0,0,1-.072.025Zm-.05-.165c.02.024.039.048.058.073l.418-.4A2.5,2.5,0,0,0,9.9,9.648v.567a1.911,1.911,0,0,1,1.337.679Z",
    fill: "#88aef1",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOps);
export default __webpack_public_path__ + "static/media/DevOps.6b6f8f522705e6945e52b10af8651944.svg";
export { ForwardRef as ReactComponent };